export default __webpack_public_path__ + "static/media/i137vp.712bb447.webp";